/**
 * Confetti effect helper
 */
export function triggerConfetti() {
  const container = document.createElement('div');
  container.className = 'confetti-container';
  container.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 9999;
    overflow: hidden;
  `;
  document.body.appendChild(container);

  const colors = ['#FF6B00', '#FF8C00', '#FFA266', '#22c55e', '#FFC299', '#ffffff'];
  const particleCount = 50;

  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement('div');
    const color = colors[Math.floor(Math.random() * colors.length)];
    const x = Math.random() * 100;
    const delay = Math.random() * 0.5;
    const duration = 2 + Math.random() * 2;

    particle.style.cssText = `
      position: absolute;
      top: -10px;
      left: ${x}vw;
      width: 10px;
      height: 10px;
      background: ${color};
      border-radius: 2px;
      animation: confetti-fall ${duration}s ease-out ${delay}s forwards;
    `;
    container.appendChild(particle);
  }

  // CSS Animation hinzufügen
  if (!document.getElementById('confetti-style')) {
    const style = document.createElement('style');
    style.id = 'confetti-style';
    style.textContent = `
      @keyframes confetti-fall {
        0% { transform: translateY(0) rotate(0deg); opacity: 1; }
        100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
      }
    `;
    document.head.appendChild(style);
  }

  setTimeout(() => container.remove(), 4000);
}
